import styled from 'styled-components';

export const Page = styled.div`
  padding: 20px;
`;
export const Back = styled.button`
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 50%;
  padding: 4px;
  cursor: pointer;
  transition: background .2s;
  &:hover {
    background: rgba(0,157,221,0.1);
  }

`;
export const Container = styled.div`
  border-radius: 10px;
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  padding: 15px 10px;
  margin-top: 30px;
  margin-bottom: 30px;

  
  h2 {
      font-family: 'Roboto';
      font-weight: 500;
      font-size: 22px;
      padding-bottom: 15px;
      text-align: center;
      border-bottom: 1px solid #D3D3D3;
    }
  .actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;

  }
`;

export const LinkContent = styled.div`
  background: #fff;
  border-radius: 10px;
  h3 {
    font-family: 'Roboto', sans-serif;
    font-weight: 600;
    font-size: 21px;
    margin-bottom: 8px;
  }

  h4 {
    font-family: 'Roboto', sans-serif;
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 5px;
  }

  .input-group {
    padding: 10px 0;
  }

  .input-group:not(:last-child) {
    border-bottom: 1px solid #D3D3D3;
  }

  .receiver {
    margin-bottom: 10px;
  }

  


  .wrapper {
    margin-bottom: 5px;

    p {
        font-family: 'Inter', sans-serif;
        font-size: 17px;
    }

    p + p {
      margin-top: 6px;
    }

    .situation {
      font-size: 18px;
    }

    .op, .canal {
      font-size: 15px;
    }
  }

  .details {
    p {
      font-size: 15px;
    }
  }
  .flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

`;

// export const LinkContent = styled.div`
//   border-bottom: 1px solid #D3D3D3;
//   padding: 15px 0;
//   margin-bottom: 15px;
//   h3 {
//     font-family: 'Roboto', sans-serif;
//     font-weight: 600;
//     font-size: 21px;
//     margin-bottom: 8px;
//   }
//   h4 {
//     font-family: 'Roboto', sans-serif;
//     font-weight: 600;
//     font-size: 18px;
//     margin-bottom: 5px;
//   }


//   .wrapper {
//     margin-bottom: 5px;

//     p {
//         font-family: 'Inter', sans-serif;
//         font-size: 17px;
//     }
//   }
//   .flex {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//   }
// `;
